module.exports = __webpack_public_path__ + "img/在线生成统计报表.81b42a6d.png";